module.exports = __webpack_public_path__ + "img/customer-icon-dark.4dbc3f03.svg";